import script from "./PricingBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./PricingBanner.vue?vue&type=script&setup=true&lang=js"

import "./PricingBanner.vue?vue&type=style&index=0&id=53e9a3b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53e9a3b6"]])

export default __exports__